import type { ReactNode } from 'react'
import { useT } from '../../contexts/LocaleContext'

// Shared pitch chrome: grass, blue rim, scrolling boards, and line markings.
// Slot layout stays in the caller so formation logic is unchanged.
export default function FootballPitchShell({
  children,
  boardText,
  className = '',
}: {
  children: ReactNode
  boardText?: string
  className?: string
}) {
  const t = useT()
  const label = boardText ?? t('dreamTeam.brandBoard')

  return (
    <div className={`football-pitch ${className}`.trim()}>
      <div className="football-pitch-board football-pitch-board-top" aria-hidden>
        <span>{label} · {label}</span>
      </div>
      <div className="football-pitch-board football-pitch-board-bottom" aria-hidden>
        <span>{label} · {label}</span>
      </div>
      <div className="football-pitch-board football-pitch-board-left" aria-hidden>
        <span>{label}</span>
      </div>
      <div className="football-pitch-board football-pitch-board-right" aria-hidden>
        <span>{label}</span>
      </div>

      <div className="football-pitch-field">
        <div className="football-pitch-mark football-pitch-halfway" />
        <div className="football-pitch-mark football-pitch-circle" />
        <div className="football-pitch-mark football-pitch-penalty-top" />
        <div className="football-pitch-mark football-pitch-penalty-bottom" />
        <div className="football-pitch-slots">{children}</div>
      </div>
    </div>
  )
}
